import {
  headingColor,
  headingFont,
  headingLg,
  headingMd,
  headingSm,
  headingXl,
  headingXs,
  headingXxs,
  textColor,
  textLg,
  textMd,
  textSm,
  textXs,
  textXxs,
} from '@insify/design-system/typography';
import clsx from 'clsx';

import * as styles from './Text.module.css';

import type React from 'react';

const headingSizeStyle = {
  xxs: headingXxs,
  xs: headingXs,
  sm: headingSm,
  md: headingMd,
  lg: headingLg,
  xl: headingXl,
};

type HeadingProps = { children: React.ReactNode; size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl'; className?: string };
export const Heading = ({ children, size = 'sm', className }: HeadingProps) => (
  <header className={clsx(headingSizeStyle[size], headingColor, headingFont, styles.heading, className)}>
    {children}
  </header>
);

const textSizeStyle = {
  xxs: textXxs,
  xs: textXs,
  sm: textSm,
  md: textMd,
  lg: textLg,
};

type ParagraphProps = { children: React.ReactNode; size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg'; className?: string };
export const Paragraph = ({ children, size = 'md', className }: ParagraphProps) => (
  <p className={clsx(textSizeStyle[size], textColor, styles.paragraph, className)}>{children}</p>
);
